import httpClient from '../httpClient';

const getAllByCountry = async (countryId) => {
  return await httpClient.get(`/city/?filter[country]=${countryId}`);
};

export {
  getAllByCountry,
};